import { AtSign, CalendarBlank, LocationPin } from '@/client/components/icons/ContinuIcons';
import { HStack, Stack, Text } from '@chakra-ui/react';

import type { User as UserType } from '@/client/types/User';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface AboutSectionProps {
  userData: UserType;
}

export default function AboutSection({ userData }: AboutSectionProps) {
  const { t } = useTranslation();
  const { email, about, hired, linked_locations: linkedLocations } = userData;

  // Function to strip HTML tags from text
  const stripHtmlTags = (html: string): string => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const cleanAbout = about ? stripHtmlTags(about) : '';

  const detailsMap = [
    {
      render: !!email,
      value: email,
      icon: <AtSign />,
    },
    {
      render: !!linkedLocations.length,
      value: linkedLocations[0]?.name || '',
      icon: <LocationPin />,
    },
    {
      render: !!hired,
      value: t('learners.profile.userDetails.startedDate', {
        date: format(new Date(hired || new Date()), 'MMMM, yyyy'),
      }),
      icon: <CalendarBlank color="baseBlack" />,
    },
  ];

  return (
    <Stack spacing={4}>
      {!cleanAbout && (
        <Text fontSize="16px" fontWeight={400} textDecoration="italic" color="neutral.800">
          {t('learners.profile.userDetails.noBio')}
        </Text>
      )}

      {cleanAbout && (
        <Text fontSize="16px" fontWeight={400} color="baseBlack">
          {cleanAbout}
        </Text>
      )}

      <Stack spacing={2}>
        {detailsMap.map(
          (detail) =>
            detail.render && (
              <HStack key={detail.value} spacing={1.5}>
                {detail.icon}

                <Text fontSize="16px" fontWeight={400} color="baseBlack">
                  {detail.value}
                </Text>
              </HStack>
            ),
        )}
      </Stack>
    </Stack>
  );
}
